var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDayBookReport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 48,
    viewBox: "0 0 60 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 48,
    rx: 5,
    fill: "#F2F2F2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.0005 10.5H18.0005C16.346 10.5 15.0005 11.8455 15.0005 13.5V34.5C15.0005 36.1545 16.346 37.5 18.0005 37.5H42.0005C43.655 37.5 45.0005 36.1545 45.0005 34.5V13.5C45.0005 11.8455 43.655 10.5 42.0005 10.5ZM40.5005 16.5V19.5H33.0005V16.5H40.5005ZM33.0005 22.5H40.5005V25.5H33.0005V22.5ZM18.0005 34.5V13.5H28.5005V34.5H18.0005Z",
    fill: "#828282"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDayBookReport);
export default __webpack_public_path__ + "static/media/day-book-report.9be7d950fc61d1e6eecd742f9892105c.svg";
export { ForwardRef as ReactComponent };